import { render, staticRenderFns } from "./scrollFull.vue?vue&type=template&id=01cfd6f4&scoped=true&"
import script from "./scrollFull.vue?vue&type=script&lang=js&"
export * from "./scrollFull.vue?vue&type=script&lang=js&"
import style0 from "./scrollFull.vue?vue&type=style&index=0&id=01cfd6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cfd6f4",
  null
  
)

export default component.exports